import React, { Component } from 'react';
import { Label } from 'atoms/Texts';
import Breadcrumb from 'molecules/Breadcrumb';
import DataTables from 'organisms/DataTable';
import { editGroupFormatter, checkFormatter } from 'molecules/TableFormatters';
import GroupMgmtModal from 'organisms/GroupMgmtModal';
import ModalPage from 'templates/ModalPage';
import { NewGroup } from 'fixtures/TemplateData';
import { GET_GROUPS, PERMISSIONS } from 'fixtures/api';
import { groupCreate, groupUpdate } from 'fixtures/permissions';
import { permissionCheck } from 'helpers/permissionCheckHelper';
import { postNewData, patchData } from 'services/cmsService';
import { getAllGroupsData, getPermissionsByGroupId, editPermissionData } from 'Redux/actions/GroupMgmtActions';
import { toggleIsLoading } from 'Redux/actions/ViewStateActions';
import { setLocalSettingsTableData } from 'Redux/actions/SettingsTableActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withTheme } from 'styled-components';
import {
  TxtSuccessSubmitGroup,
  TxtFailedUpdate,
  TxtFailedSubmitData
} from 'fixtures/texts';
import {
  PageWrapper,
  SplitTableWrapper,
  ScrollableWrapper,
  TableLeftWrapper,
  TableRightWrapper,
  LabelCountSpan
} from './styles';

import lo from 'lodash';

export class GroupManagement extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isShowModal: false,
      isSubmitDisabled: false,
      groupData: {},
      groupSelectConfig: {
        mode: 'radio',
        clickToSelect: true,
        clickToEdit: true,
        hideSelectColumn: true,
        onSelect: this.onSelectGroup.bind(this),
        style: { backgroundColor: this.props.theme.getRGBA(this.props.theme.mocaPurple, 0.19) }
      },
      defaultSorted: [{
        dataField: 'id',
        order: 'asc'
      }],
      selectedGroupId: '',
      navList: [
        'Management User',
        'Group and Permissions'
      ],
      allowCreate: false,
      allowUpdate: false,
      sizePerPage: undefined,
    }
  }

  componentDidMount() {
    this.props.toggleIsLoading(true)
    this.props.getAllGroupsData()
    this.checkPermission()
  }

  componentDidUpdate(prevProps) {
    const { groupList, viewState: { isLoading }, userLogin } = this.props
    if (prevProps.groupList !== groupList && isLoading) {
      this.props.toggleIsLoading(false)
    }
    if (prevProps.userLogin !== userLogin) {
      this.checkPermission()
    }
  }

  // method for checking access permission
  checkPermission() {
    const { userLogin } = this.props
    if (userLogin && userLogin.userDetail) {
      const { userDetail: { permissions } } = userLogin
      this.setState({
        allowCreate: permissionCheck(permissions, groupCreate),
        allowUpdate: permissionCheck(permissions, groupUpdate),
      })
    }
  }

  // method on group data change
  onChangeGroupData(val, field) {
    let group = Object.assign(this.state.groupData)
    group[field] = val
    this.setState({ groupData: group })
  }

  // method for adding new group
  addNewGroup() {
    this.switchModal(lo.cloneDeep(NewGroup))
  }

  // method for submitting group
  onSubmitGroup() {
    const { groupData: { id, name } } = this.state
    const cloned = lo.cloneDeep({ id, name })

    const uri = cloned.hasOwnProperty('createdAt') ?
      `${GET_GROUPS}/${cloned.id}` :
      GET_GROUPS

    this.setState({ isSubmitDisabled: true }, async () => {
      try {
        const res = cloned.hasOwnProperty('createdAt') ?
          await patchData(uri, cloned) :
          await postNewData(uri, cloned)

        if (res.status === 201 || res.status === 204) {
          alert(TxtSuccessSubmitGroup)
          this.setState({ isSubmitDisabled: false })
          this.props.getAllGroupsData()
          this.switchModal(NewGroup)
        } else {
          throw res
        }
      } catch (err) {
        alert(TxtFailedSubmitData)
        this.setState({ isSubmitDisabled: false })
      }
    })
  }

  // method for switching the checkbox value
  switchCheck(row, field) {
    row[field] = !row[field]
    this.props.editPermissionData(row)
    this.submitPermissions()
  }

  // method on selecting group
  onSelectGroup(row, isSelect, rowIndex, e) {
    this.setState({ selectedGroupId: row.id })
    this.props.getPermissionsByGroupId(row.id)
  }

  // method for switching the modal view
  switchModal(groupData) {
    const { isShowModal } = this.state
    this.setState({ groupData: groupData }, () => {
      this.setState({ isShowModal: !isShowModal })
    })
  }

  onSizePerPageChange = (size) => {
    const { setLocalSettingsTableData, settingsTable } = this.props
    const settings = lo.cloneDeep(settingsTable)
    settings.sizePerPage[this.state.navList[0]] = size
    setLocalSettingsTableData(settings)
  }

  // method for submitting permission changes
  async submitPermissions() {
    const sendObj = {
      groupId: this.state.selectedGroupId,
      permissions: lo.cloneDeep(this.props.permissionList)
    }

    try {
      const res = await postNewData(PERMISSIONS(), sendObj)
      if (res.status !== 500) { } else {
        throw res
      }
    } catch (err) {
      alert(TxtFailedUpdate)
    }
  }

  // rendering the left slot of the header
  renderLeftSlot(count, txt) {
    return (
      <LabelCountSpan>
        <Label lineheight={'22px'} size={'18px'}>{txt}</Label>
        <Label lineheight={'22px'} size={'18px'} weight={'400'} color={this.props.theme.mocaGrey}>
          &nbsp;({count})
        </Label>
      </LabelCountSpan>
    )
  }

  render() {
    const {
      isShowModal,
      isSubmitDisabled,
      groupData,
      groupSelectConfig,
      defaultSorted,
      navList,
    } = this.state
    const { groupList, permissionList, settingsTable, viewState: { isLoading, isMobileView } } = this.props

    const sizePerPage = settingsTable.sizePerPage[navList[0]]

    const groupConfig = [
      {
        dataField: 'name',
        text: 'Name',
        headerStyle: { display: 'none' },
        style: { border: 'none' }
      },
      {
        dataField: 'action',
        text: 'Action',
        sort: false,
        align: 'right',
        headerStyle: { display: 'none' },
        style: { border: 'none' },
        formatter: editGroupFormatter,
        formatExtraData: {
          allowEdit: this.state.allowUpdate,
          edit: (row) => this.switchModal.bind(this, row)
        },
        isDummyField: true
      }
    ]

    const permissionConfig = [
      {
        dataField: 'id',
        text: 'No',
        headerAttrs: { width: 50 },
        sort: true
      },
      {
        dataField: 'displayName',
        text: 'Menu',
        sort: true
      },
      {
        dataField: 'allowRead',
        text: 'Read',
        formatter: checkFormatter,
        formatExtraData: {
          allowEdit: this.state.allowUpdate,
          field: 'allowRead',
          fn: (row, field) => this.switchCheck.bind(this, row, field)
        },
        sort: true
      },
      {
        dataField: 'allowCreate',
        text: 'Create',
        formatter: checkFormatter,
        formatExtraData: {
          allowEdit: this.state.allowUpdate,
          field: 'allowCreate',
          fn: (row, field) => this.switchCheck.bind(this, row, field)
        },
        sort: true
      },
      {
        dataField: 'allowUpdate',
        text: 'Edit',
        formatter: checkFormatter,
        formatExtraData: {
          allowEdit: this.state.allowUpdate,
          field: 'allowUpdate',
          fn: (row, field) => this.switchCheck.bind(this, row, field)
        },
        sort: true
      },
      {
        dataField: 'allowDelete',
        text: 'Delete',
        formatter: checkFormatter,
        formatExtraData: {
          allowEdit: this.state.allowUpdate,
          field: 'allowDelete',
          fn: (row, field) => this.switchCheck.bind(this, row, field)
        },
        sort: true
      },
      {
        dataField: 'allowApproval',
        text: 'Approval',
        formatter: checkFormatter,
        formatExtraData: {
          allowEdit: this.state.allowUpdate,
          field: 'allowApproval',
          fn: (row, field) => this.switchCheck.bind(this, row, field)
        },
        sort: true
      },
      {
        dataField: 'allowAcknowledge',
        text: 'Acknowledge',
        formatter: checkFormatter,
        formatExtraData: {
          allowEdit: this.state.allowUpdate,
          field: 'allowAcknowledge',
          fn: (row, field) => this.switchCheck.bind(this, row, field)
        },
        sort: true
      },
      {
        dataField: 'allowCheck',
        text: 'Check',
        formatter: checkFormatter,
        formatExtraData: {
          allowEdit: this.state.allowUpdate,
          field: 'allowCheck',
          fn: (row, field) => this.switchCheck.bind(this, row, field)
        },
        sort: true
      },
      {
        dataField: 'allowEmail',
        text: 'Email',
        formatter: checkFormatter,
        formatExtraData: {
          allowEdit: this.state.allowUpdate,
          field: 'allowEmail',
          fn: (row, field) => this.switchCheck.bind(this, row, field)
        },
        sort: true
      }
    ]

    return (
      <PageWrapper isMobile={isMobileView}>
        <Breadcrumb navList={navList} />
        <ModalPage
          height={'300px'}
          isOpen={isShowModal}
          fnSwitch={this.switchModal.bind(this)}
          contentChild={
            <GroupMgmtModal
              fnChange={this.onChangeGroupData.bind(this)}
              fnSubmit={this.onSubmitGroup.bind(this)}
              fnSwitch={this.switchModal.bind(this)}
              groupData={groupData}
              isDisabled={isSubmitDisabled}
              {...this.props}
            />
          }
        />
        {!isLoading &&
          <SplitTableWrapper>
            <ScrollableWrapper>
              <TableLeftWrapper>
                <DataTables
                  minWidth={'205px'}
                  leftSlot={this.renderLeftSlot(groupList.length, 'Group')}
                  rightSlotAlt={true}
                  allowAdd={this.state.allowCreate}
                  fnAdd={this.addNewGroup.bind(this)}
                  dataList={groupList}
                  columnConfig={groupConfig}
                  selectConfig={groupSelectConfig}
                  noStripe={true}
                />
              </TableLeftWrapper>
              <TableRightWrapper>
                <DataTables
                  minWidth={'500px'}
                  isMobile={isMobileView}
                  leftSlot={this.renderLeftSlot(permissionList.length, 'Permissions')}
                  dataList={permissionList}
                  columnConfig={permissionConfig}
                  defaultSorted={defaultSorted}
                  containerClassName="table-responsive px-3"
                  sizePerPage={sizePerPage}
                  onSizePerPageChange={this.onSizePerPageChange}
                />
              </TableRightWrapper>
            </ScrollableWrapper>
          </SplitTableWrapper>
        }
      </PageWrapper>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    groupList: state.groupList,
    permissionList: state.permissionList,
    userLogin: state.userLogin,
    viewState: state.viewState,
    settingsTable: state.settingsTable
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getAllGroupsData,
      getPermissionsByGroupId,
      editPermissionData,
      toggleIsLoading,
      setLocalSettingsTableData,
    },
    dispatch
  )

export default withTheme(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(GroupManagement)
);
